export default class User {
  [key: string]: string;
}
